import { memo, useCallback } from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { PinRegular, PinFilled } from '@fluentui/react-icons';
import { useTimeGridStyles } from '../useTimeGridStyles';

type PinButtonProps = {
    pinned: boolean;
    onToggle: () => void;
};

export const PinButton = memo(function PinButton({ pinned, onToggle }: PinButtonProps) {
    const styles = useTimeGridStyles();

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            onToggle();
        },
        [onToggle],
    );

    return (
        <Button
            className={mergeClasses('fui-trigger-pin', styles.pinTrigger, pinned && styles.pinTriggerPinned)}
            appearance="subtle"
            size="small"
            icon={pinned ? <PinFilled /> : <PinRegular />}
            aria-label={pinned ? 'Unpin task' : 'Pin task'}
            tabIndex={-1}
            onClick={handleClick}
        />
    );
});
